import React, { useState, useEffect , useContext} from "react";
import { Row, Col } from "react-bootstrap";
import RentalAdminSidebar from "../../components/equipmentrentaladmin/AdminSidebar/RentalAdminSidebar";
import AdminTopNavbar from "../../components/equipmentrentaladmin/admintonavpbar/AdminTopNavbar";
import '../../assets/css/equipmentrentaladmin/rentaladminlayout/RentalAdminLayout.css';
import AppContext from "../../context/AppContext";


const RentalAdminLayout = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const {setAuthToken, setLoggedInRental} = useContext(AppContext);

  // Check if screen is mobile on mount and resize
  useEffect(() => {
    const checkMobile = () => { 
      setIsMobile(window.innerWidth <= 768);
      if (window.innerWidth > 768) {
        setIsSidebarOpen(false);
      }
    };

    checkMobile();
    window.addEventListener('resize', checkMobile);
    
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

    useEffect(()=>{
      const authToken = localStorage.getItem("authToken");
      setAuthToken(authToken); 
  
      const savedRentalAdmin = JSON.parse(localStorage.getItem("LoggedInRental"));
      setLoggedInRental(savedRentalAdmin);
      
    } ,[]);

  return (
    <div className="rental-admin-master-layout">
      <Row className="rental-g-0">
        {/* Desktop Sidebar */}
        <Col lg={3} md={4} className={`rental-sidebar-col ${isMobile ? 'd-none' : ''}`}>
          <RentalAdminSidebar isOpen={false} onClose={closeSidebar} />
        </Col>
        
        {/* Mobile Sidebar - Shown as overlay */}
        {isMobile && (
          <RentalAdminSidebar isOpen={isSidebarOpen} onClose={closeSidebar} />
        )} 

        {/* Main Content */}
        <Col lg={9} md={8} sm={12} className="rental-content-col">
          <AdminTopNavbar 
            onToggleSidebar={toggleSidebar} 
            isSidebarOpen={isSidebarOpen}
          />
          <div className="rental-admin-content-wrapper">
            {children}
          </div>
        </Col>
      </Row>
    </div>
  );
};
export default RentalAdminLayout;